import { useStaticQuery, graphql } from 'gatsby';

type AllProductQuery = {
  contentfulCatalog: {
    collections: {
      products: Queries.ProductBaseFragment[];
    }[];
  };
};

const useProducts = () => {
  const data = useStaticQuery<AllProductQuery>(graphql`
    query AllProducts {
      contentfulCatalog(slug: { eq: "catalog" }) {
        collections {
          products {
            ...ProductBase
          }
        }
      }
    }
  `);

  const products = data.contentfulCatalog.collections.reduce(
    (acc: Queries.ProductBaseFragment[], c) => (!c.products ? acc : [...acc, ...c.products]),
    []
  );

  return products;
};

export default useProducts;
